import { Tag } from "../service/tagService";
import { Button } from "@/shared/ui/button";
import { Edit } from "lucide-react";
import { Badge } from "@/shared/ui/badge";
import { DataTable } from "@/shared/widgets";
import { useTranslation } from "@/shared/i18n";

interface TagsTableProps {
    tags: Tag[];
    isLoading: boolean;
    onEdit: (tag: Tag) => void;
}

export function TagsTable({ tags, isLoading, onEdit }: TagsTableProps) {
    const { t } = useTranslation('tags');
    
    return (
        <DataTable
            data={tags}
            isLoading={isLoading}
            emptyTitle={t('emptyTitle')}
            emptyDescription={() => t('emptyDescription')}
            columns={[
                {
                    header: t('name'),
                    cell: (tag) => {
                        const ptBrName = tag.translations.find(t => t.languageCode === 'PT_BR')?.name || t('noName');
                        return <span className="text-white">{ptBrName}</span>;
                    },
                },
                {
                    header: t('status'),
                    cell: (tag) => (
                        <Badge variant={tag.published ? 'default' : 'secondary'}>
                            {tag.published ? t('published') : t('draft')}
                        </Badge>
                    ),
                },
                {
                    header: t('type'),
                    cell: (tag) => (
                        <span className="text-white/60">
                            {tag.isCategory ? t('category') : t('tag')}
                        </span>
                    ),

                },
                {
                    header: t('actions'),
                    cell: (tag) => (
                        <div className="flex justify-end gap-2">
                            <Button
                                variant="ghost"
                                size="icon"
                                onClick={() => onEdit(tag)}
                                title={t('edit')}
                            >
                                <Edit className="h-4 w-4" />
                            </Button>
                        </div>
                    ),
                    className: "text-right w-[100px]",
                },
            ]}
        />
    );
}